import * as React from 'react'

import { Box, IconBadge, NumberBadge, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type ContractFlow from 'modules/contracts/lib/ContractFlow'
import type ContractFlowStep from 'modules/contracts/lib/ContractFlowStep'

interface Props {
  flow: ContractFlow
  step: ContractFlowStep
  stepNumber: number
  setCurrentStep: (step: number) => void
}

export const MenuItem = observer(({ flow, step, stepNumber, setCurrentStep }: Props) => {
  const currentStepNumber = flow.currentStepNumber
  const isHighlighted = currentStepNumber === stepNumber
  const isCompleted = currentStepNumber > stepNumber
  const isPending = currentStepNumber < stepNumber
  const stepLabel = stepNumber + 1

  const onStepClicked = () => {
    if (isCompleted) {
      flow.currentStepNumber = stepNumber
      setCurrentStep(stepNumber)
    }
  }

  return (
    <Box
      padding="s6"
      flexDirection="row"
      gap="s8"
      alignItems="center"
      background={isHighlighted ? 'grey200' : undefined}
      borderRadius={{
        all: 'abs008',
      }}
      width="full"
      cursor={isCompleted ? 'pointer' : 'default'}
      onClick={() => onStepClicked()}
    >
      {isCompleted && <IconBadge icon="check" iconColor="viridian1000" color="viridian200" />}
      {isHighlighted && (
        <NumberBadge label={stepLabel} color="darker800" textColor="grey000White" />
      )}
      {isPending && <NumberBadge label={stepLabel} color="grey200" textColor="darker800" />}
      <Text weight="medium" size="200" color={isCompleted ? 'viridian1200' : 'grey800'}>
        {step.title}
      </Text>
    </Box>
  )
})
